import { useEffect } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

export default function ScrollManager() {
  const location = useLocation();
  const navigationType = useNavigationType();

  useEffect(() => {
    if (navigationType === "PUSH") {
      window.scrollTo(0, 0);   // scroll to top on new page
    }
    // For POP (back/forward), let the browser restore the scroll
  }, [location, navigationType]);

  return null;
}